import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../../../user/services';

@Injectable({
  providedIn: 'root',
})
export class ExternalVendorGuardService {
  constructor(private userService: UserService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.userService.showMoxeInventory$();
  }
}
